export default "__VITE_ASSET__BwEDVaO0__"